import React, { useEffect, useMemo, useState } from "react";
import Table from "../../components/utils/Table";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import { downloadExcelSampleFile, maskEmail, isAdmin } from "../../helpers/commonFunction";
import CardLayout from "../../components/utils/CardLayout";
import ToastAlert from "../../components/utils/ToastAlert";
import dealerActions from "../../redux/dealer/actions";
import Modal from '../../components/utils/Modal';
import moment from "moment";
import { useNavigate } from 'react-router-dom';


const { createDealer, getDealerList, resetMessage, modifyDealer, resetPasswordByAdmin } = dealerActions;
const dateFormat = process.env.REACT_APP_DATE_TIME_FORMAT;



const Dealer = () => {
  const dispatch = useDispatch();
  const [searchItem, setSearchItem] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [showEmail, setShowEmail] = useState(true);
  const [emailInput, setEmailInput] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const { dealerList, createDealerError, createDealerMessage, getDealerListLoading, modifyDealerLoading, modifyDealerError, modifyDealerMessage, createDealerLoading, resetPasswordByAdminLoading, resetPasswordByAdminError, resetPasswordByAdminMessage } = useSelector((state) => state.dealer);
  const { tokenData } = useSelector((state) => state.auth);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [hideConfirmDealerId, setHideConfirmDealerId] = useState('');
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [isDealerEdit, setIsDealerEdit] = useState(false);
  const [updateDealerId, setUpdateDealerId] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [hiddenDealerFlag, sethiddenDealerFlag] = useState(1);

  const { register, handleSubmit, reset, watch, setValue, clearErrors, formState: { errors }, } = useForm({
    mode: "onChange",
    defaultValues: {
      dealerId: "",
      userId: "",
      dealerName: "",
      password: "",
      email: "",
      isActive: true
    },
  });

  const { register: registerResetPw, handleSubmit: handleSubmitResetPw, reset: resetResetPw, watch: watchResetPw, clearErrors: clearErrorsResetPw, formState: { errors: errorsResetPw }, } = useForm({
    mode: "onChange",
    defaultValues: {
      newpass: "",
      confirmPassword: ""
    },
  });


  useEffect(() => {
    dispatch(getDealerList({ actionType: hiddenDealerFlag }));
  }, [hiddenDealerFlag]);

  useEffect(() => {
    if (createDealerError) {
      ToastAlert({ type: "error", text: createDealerError, });
    }
    if (createDealerMessage) {
      ToastAlert({ type: "success", text: createDealerMessage, });
      closeModal();
      dispatch(resetMessage());
      dispatch(getDealerList({ actionType: hiddenDealerFlag }));
      setOpenSuccessModal(true)
    }

    if (modifyDealerError) {
      ToastAlert({
        type: "error",
        text: modifyDealerError,
      });
      dispatch(resetMessage());
      return;
    }

    if (modifyDealerMessage) {
      ToastAlert({
        type: "success",
        text: modifyDealerMessage,
      });
      closeModal();
      setConfirmAction(null);
      setHideConfirmDealerId('')
      dispatch(getDealerList({ actionType: hiddenDealerFlag }));
      dispatch(resetMessage());
    }
  }, [createDealerError, createDealerMessage, modifyDealerError, modifyDealerMessage,]);


  const filteredItems = useMemo(() => {
    return Array.isArray(dealerList)
      ? dealerList.filter(itm => itm?.DistributorID != 1)
        .filter((item) => {
          if (!searchItem) return true;

          return Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(searchItem.toLowerCase())
          );
        })
      : [];
  }, [dealerList, searchItem, hiddenDealerFlag]);

  const handleAddDealerSubmit = (data) => {
    if (isDealerEdit) {
      const payload = {
        distributorID: updateDealerId,
        dealerId: data.dealerId,
        dealerName: data.dealerName,
        actionType: 3,
      };

      dispatch(modifyDealer(payload));
      return;
    }

    const payload = {
      dealerId: data.dealerId,
      userId: data.userId,
      dealerName: data.dealerName,
      password: data.password,
      emailId: emailInput,
      isActive: data.isActive,
    };
    dispatch(createDealer(payload));
  };

  useEffect(() => {
    if (!confirmAction) return;

    const handleOutsideClick = (event) => {
      const popup = document.querySelector(".dealer-confirm-popup");

      if (popup && !popup.contains(event.target)) {
        setConfirmAction(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [confirmAction]);

  useEffect(() => {
    if (!hideConfirmDealerId) return;

    const handleOutsideClickHide = (event) => {
      const popup = document.querySelector(".dealer-hide-confirm-popup");

      if (popup && !popup.contains(event.target)) {
        setHideConfirmDealerId('');
      }
    };

    document.addEventListener("mousedown", handleOutsideClickHide);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClickHide);
    };
  }, [hideConfirmDealerId]);


  const handleStatusChange = (item) => {
    const newStatus = !item?.IsActive;
    setConfirmAction({
      distributorId: item?.DistributorID,
      isActive: newStatus,
    });
  };

  const handleHideDealer = (item) => {
    setHideConfirmDealerId(item?.DistributorID);
  }

  const handleConfirmStatusChange = (actionType) => {

    if (actionType == 1 && !confirmAction?.distributorId) {
      ToastAlert({
        type: "error",
        text: "Dealer ID is not available.",
      });
      return;
    }

    if (actionType == 2 && !hideConfirmDealerId) {
      ToastAlert({
        type: "error",
        text: "Dealer ID is not available.",
      });
      return;
    }

    const payload = actionType == 1 ? {
      distributorID: confirmAction.distributorId,
      isActive: confirmAction?.isActive,
      actionType: actionType
    } : {
      distributorID: hideConfirmDealerId,
      isActive: false,
      actionType: actionType
    };

    dispatch(modifyDealer(payload));
  };

  const handleUserNavigate = (item) => {
    navigate("/admin/user", {
      state: {
        DistributorID: item?.DistributorID,
      }
    });
  }

  const handleDealerResetPassword = (data) => {
    const payload = {
      distributorID: selectedDealer?.DistributorID,
      newpass: data.newpass.trim(),
      confirmPassword: data.confirmPassword.trim(),
    }
    dispatch(resetPasswordByAdmin(payload));
  }

  const closeResetPasswordModal = () => {
    resetResetPw();
    setShowResetModal(false);
    setSelectedDealer(null);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };
  useEffect(() => {
    if (resetPasswordByAdminMessage) {
      ToastAlert({ type: "success", text: resetPasswordByAdminMessage });
      closeResetPasswordModal();

    }

    if (resetPasswordByAdminError) {
      ToastAlert({ type: "error", text: resetPasswordByAdminError });
    }
  }, [resetPasswordByAdminMessage, resetPasswordByAdminError]);



  const dataSource = useMemo(() => {
    return filteredItems.map((item, index) => ({
      key: index + 1,
      distributorId: item?.DistributorID ?? "-",
      dealerName: item?.DealerName ?? "-",
      dealerId: item?.DealerID ?? "-",
      aCode: item?.ACode ?? "-",
      status: (<span style={{ textAlign: "center" }} className={`badge ${item?.IsActive ? "bg-success-subtle text-success" : "bg-danger-subtle text-danger"}`}>
        {item?.IsActive ? "Active" : item?.IsHide ? "Hidden" : "Inactive"}
      </span>),
      createdDate: item?.CreatedDtTm ? moment(item.CreatedDtTm).format(dateFormat) : "-",
      lastModifiedDate: item?.LastModifiedDtTm ? moment(item.LastModifiedDtTm).format(dateFormat) : "-",
      action: (
        !item?.IsHide && <div
          className="position-relative d-flex gap-2"
          style={{ width: "fit-content" }}
        >
          <button
            type="button"
            className={`btn btn-sm rounded-circle ${item?.IsActive
              ? "bg-danger-subtle text-danger "
              : "bg-success-subtle text-success "
              }`}
            title={item?.IsActive ? "Deactivate" : "Activate"}
            onClick={() => handleStatusChange(item)}
            disabled={modifyDealerLoading}
          >
            <i
              className={
                item?.IsActive
                  ? "ri-delete-bin-line"
                  : "ri-checkbox-circle-line"
              }
            />
          </button>

          {confirmAction?.distributorId === item?.DistributorID && (
            <div
              className="dealer-confirm-popup position-absolute bg-white border rounded shadow-sm p-3"
              style={{
                zIndex: 1050,
                minWidth: "220px",
                right: "100%",
                top: "50%",
                transform: "translateY(-50%)",
                marginRight: "8px",
              }}
            >
              <h6 className="mb-2 text-center">
                Are you sure you want{" "}
                <strong>
                  {confirmAction?.isActive ? "activate" : "deactivate"}
                </strong>{" "}
                this dealer?{!confirmAction?.isActive && <><br /> <i><small><span className="text-danger">Note:</span> This action will also deactivate all users under this dealer.</small></i></>}
              </h6>

              <div className="d-flex justify-content-center gap-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleConfirmStatusChange(1)}
                  disabled={modifyDealerLoading}
                >
                  {modifyDealerLoading ? "..." : "Yes"}
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => setConfirmAction(null)}
                  disabled={modifyDealerLoading}
                >
                  No
                </button>
              </div>
            </div>
          )}

          {isAdmin(tokenData) && !item?.IsActive && <button
            type="button"
            className={`btn btn-sm rounded-circle bg-danger-subtle text-danger`}
            title='Hide Dealer'
            onClick={() => handleHideDealer(item)}
            disabled={modifyDealerLoading}
          >
            <i className="ri-user-unfollow-fill" />
          </button>}

          {hideConfirmDealerId && (hideConfirmDealerId == item?.DistributorID) && (
            <div
              className="dealer-hide-confirm-popup position-absolute bg-white border rounded shadow-sm p-3"
              style={{
                zIndex: 1055,
                minWidth: "220px",
                right: "100%",
                top: "50%",
                transform: "translateY(-50%)",
                marginRight: "8px",
              }}
            >
              <h6 className="mb-2 text-center">
                Are you sure you want to hide this dealer?
                {<><br /> <i><small><span className="text-danger">Note:</span>This action will permanently hide this dealer from all relevant places.</small></i></>}
              </h6>

              <div className="d-flex justify-content-center gap-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleConfirmStatusChange(2)}
                  disabled={modifyDealerLoading}
                >
                  {modifyDealerLoading ? "..." : "Yes"}
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => setHideConfirmDealerId('')}
                  disabled={modifyDealerLoading}
                >
                  No
                </button>
              </div>
            </div>
          )}

          <button type="button" className="btn btn-sm rounded-circle btn-primary-light bg-primary-subtle"
            style={{ width: "32px", height: "32px", }}
            title="Edit" onClick={() => handleUpdateDealer(item)} >
            <i className="ri-edit-line fw-bold" />
          </button>

          <button
            type="button"
            className="btn btn-sm rounded-circle btn-blue"
            title={"Users"}
            onClick={() => handleUserNavigate(item)}
            disabled={modifyDealerLoading}
          >
            <i
              className={"ri-group-line"}
            />
          </button>

          {isAdmin(tokenData) && <button
            type="button"
            className={`btn btn-sm rounded-circle bg-success-subtle text-success `}
            title='Reset Password'
            onClick={() => { setSelectedDealer(item); setShowResetModal(true); }}
            disabled={modifyDealerLoading}
          >
            <i className="ri-rotate-lock-line" />
          </button>}
        </div>
      ),
    }));
  }, [filteredItems, modifyDealerLoading, confirmAction, hideConfirmDealerId]);

  const columns = [
    { displayName: "Sr.No.", key: "key", },
    { displayName: "ACode", key: "aCode", },
    { displayName: "Dealer ID", key: "dealerId", },
    { displayName: "Dealer Name", key: "dealerName", },
    { displayName: "Created Date", key: "createdDate", },
    { displayName: "Modified Date", key: "lastModifiedDate", },
    { displayName: "Status", key: "status", },
    { displayName: "Action", key: "action", },
  ];



  const downloadResponseFile = () => {
    const data = filteredItems.map((item, key) => ({
      "Sr.No.": key + 1,
      "ACode": item?.ACode,
      "Dealer ID": item?.DealerID,
      "Dealer Name": item?.DealerID,
      "Created Date": item?.CreatedDtTm ? moment(item.CreatedDtTm).format(dateFormat) : "-",
      "Last Modified Date": item?.LastModifiedDtTm ? moment(item.LastModifiedDtTm).format(dateFormat) : "-",
      "Status": item?.IsActive ? "Active" : item?.IsHide ? "Hidden" : "Inactive",
    }));
    downloadExcelSampleFile(data, "dealer-list.xlsx");
  };

  const openDealerModal = () => {
    reset({
      dealerId: '',
      userId: '',
      password: "",
      confirmPassword: "",
      email: "",
      dealerName: "",
      isActive: true,
    });
    setEmailInput("");
    setShowPassword(false);
    setIsOpenModal(true);
  }

  const closeModal = () => {
    setIsDealerEdit(false)
    setIsOpenModal(false);
    reset({
      dealerId: "",
      userId: "",
      password: "",
      email: "",
      isActive: true,
      dealerName: "",
    });
    clearErrors()
    setEmailInput("");
    setShowEmail(true);
    setShowPassword(false);
    setOpenSuccessModal(false)
    setUpdateDealerId('')
  }


  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    let newEmail = inputValue;
    // When the input is currently masked,
    // preserve the hidden characters from the real email.
    if (!showEmail) {
      const previousEmail = emailInput;

      const atIndex = previousEmail.indexOf("@");

      if (atIndex !== -1) {
        const previousUsername = previousEmail.substring(0, atIndex);

        const newAtIndex = inputValue.indexOf("@");

        if (newAtIndex !== -1) {
          const newUsername = inputValue.substring(0, newAtIndex);
          const newDomain = inputValue.substring(newAtIndex);

          // Keep original hidden characters
          const hiddenPart = previousUsername.substring(1);

          newEmail = newUsername.charAt(0) + hiddenPart + newDomain;
        }
      }
    }

    setEmailInput(newEmail);
    setValue("email", newEmail, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleEmailFocus = () => {
    setIsEditing(true);
  };

  const handleEmailBlur = () => {
    setIsEditing(false);
    setShowEmail(false)
  };


  const handlePageAccess = () => {
    navigate('/admin/page-access');
  }


  const handleUpdateDealer = (selectDealer) => {
    setIsDealerEdit(true)
    setUpdateDealerId(selectDealer?.DistributorID);
    setValue("dealerId", selectDealer?.DealerID || "");
    setValue("dealerName", selectDealer?.DealerName || "");
    setIsEditing(true);
    setEmailInput("");
    setShowPassword(false);
    setIsOpenModal(true);
  }


  return (
    <CardLayout title="Dealers" icon="fas fa-user-tie"
      rightContent={
        <div className="d-flex flex-wrap align-items-center gap-1">
          <>
            <small className="text-primary mb-0" style={{ fontWeight: "600", fontSize: "14px" }}>Hidden Dealer</small>
            <div
              className="d-flex align-items-center gap-1 rounded-pill p-1 me-1"
              style={{ background: "#f4f2ec", border: "1px solid #e5e2da", }}
            >
              <button
                type="button"
                className="border-0 rounded-pill px-3 py-1"
                onClick={() => sethiddenDealerFlag(1)}
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  background: hiddenDealerFlag == 1 ? "#8e0f9d" : "transparent",
                  color: hiddenDealerFlag == 1 ? "#fff" : "#6b6b66",
                }}
              >
                Hide
              </button>

              <button
                type="button"
                className="border-0 rounded-pill px-3 py-1"
                onClick={() => { sethiddenDealerFlag(2); }}
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  background: hiddenDealerFlag == 2 ? "#8e0f9d" : "transparent",
                  color: hiddenDealerFlag == 2 ? "#fff" : "#6b6b66",
                }}
              >
                Show
              </button>
            </div>
          </>

          {/* Search */}
          <input
            type="search"
            className="form-control"
            style={{ width: "250px", }}
            placeholder="Search..."
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
          />
          {/* Excel */}
          <Button
            title="Excel"
            buttonType="button"
            variant="secondary"
            icon={
              <i className="ri-download-cloud-line me-2"></i>
            }
            onClick={downloadResponseFile}
          />

          {/* Add Dealer */}
          {isAdmin(tokenData) && <Button
            title="Add Dealer"
            buttonType="button"
            variant="primary"
            icon={
              <i className="ri-add-line me-1"></i>
            }
            onClick={openDealerModal}
          />}

        </div>
      }>
      {/* Table */}
      <div>
        <Table
          columns={columns}
          loading={getDealerListLoading}
          data={dataSource}
          pagination={true}
          tableHeight="380px"
        />
      </div>
      <Modal
        showModal={isOpenModal}
        title={isDealerEdit ? "Edit Dealer" : "Add Dealer"}
        onHide={closeModal}
        width={700}
        showFooter={false}
      >
        <form className="row" onSubmit={handleSubmit(handleAddDealerSubmit)}>

          {/* Dealer ID */}
          <div className="form-group col-md-6 mb-3">
            <label className="form-label fw-semibold">
              Dealer ID{" "} <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Dealer ID"
                {...register("dealerId", {
                  required: "Dealer ID is required",
                  maxLength: {
                    value: 20,
                    message: "Maximum 20 characters allowed",
                  },
                })}

              />
            </div>
            {errors.dealerId && (
              <div className="text-danger small">
                {
                  errors.dealerId.message
                }
              </div>
            )}
          </div>
          {/* User ID */}
          {!isDealerEdit && (
            <div className="form-group col-md-6 mb-3">
              <label className="form-label fw-semibold">
                User ID{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter User ID"
                  {...register("userId", {
                    required: "User ID is required",
                    maxLength: {
                      value: 20,
                      message: "Maximum 20 characters allowed",
                    },
                  })}

                />
              </div>

              {errors.userId && (
                <div className="text-danger small">
                  {errors.userId.message}
                </div>
              )}
            </div>
          )}
          {/* Dealer Name */}
          <div className="form-group col-md-6 mb-3">
            <label className="form-label fw-semibold">
              Dealer Name{" "} <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Dealer Name"
                {...register("dealerName", {
                  required: "Dealer Name is required",
                })}
              />
            </div>
            {errors.dealerName && (<div className="text-danger small"> {errors.dealerName.message} </div>)}
          </div>
          {/* Email Address */}
          {!isDealerEdit && (
            <div className="form-group col-md-6 mb-3">
              <label className="form-label fw-semibold">
                Email Address{" "}
                <small style={{ fontSize: "10px" }}>
                  (Used only for password reset)
                </small>
                <span className="text-danger">*</span>
              </label>

              <div className="input-group position-relative">
                <input
                  type="text"
                  placeholder="Enter email address"
                  className={`form-control ${errors.email ? "is-invalid" : ""
                    }`}
                  value={showEmail || isEditing ? emailInput : maskEmail(emailInput)}
                  {...register("email", {
                    required: "Email address is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  onFocus={handleEmailFocus}
                  onBlur={handleEmailBlur}
                  onChange={handleEmailChange}
                />


                <button
                  type="button"
                  className="input-group-text"
                  onClick={() => {
                    setShowEmail(pre => !pre);
                  }}
                  style={{
                    cursor: "pointer",
                    backgroundColor: "var(--bg-content)",
                    borderColor: "var(--border-color)",
                    color: "var(--hedging-text-color)",
                    minWidth: "42px",
                    justifyContent: "center",
                  }}
                  title={showEmail ? "Hide Email" : "Show Email"}
                >
                  <i
                    className={
                      showEmail
                        ? "ri-eye-off-line"
                        : "ri-eye-line"
                    }
                    style={{ fontSize: "18px" }}
                  />
                </button>
              </div>

              {errors.email && (
                <div className="invalid-feedback d-block">
                  {errors.email.message}
                </div>
              )}
            </div>
          )}
          {/* Password */}
          {!isDealerEdit && (
            <div className="form-group col-md-6 mb-3">
              <label htmlFor="password" className="form-label fw-semibold">
                Password <span className="text-danger">*</span><span
                  className="position-relative ms-2 info-icon-wrapper"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fas fa-info-circle text-primary fs-5 info-icon-text" />
                  <div className="password-info-popup position-absolute bg-white border rounded shadow-sm py-2">
                    <ul className="mb-0 ps-4 custom-info-list">
                      <li className="mb-1"> Minimum characters 8 </li>
                      <li className="mb-1"> One uppercase character </li>
                      <li className="mb-1"> One lowercase character </li>
                      <li className="mb-1"> One special character </li>
                      <li className="mb-1"> One number </li>
                      <li className="mb-1"> e.g. Example@123 </li>
                    </ul>
                  </div>
                </span>
              </label>

              <div className="input-group">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  className={`form-control ${errors.password ? "is-invalid" : ""
                    }`}
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Use uppercase, lowercase, number & special character.",
                    },
                  })}
                />

                <span
                  className="input-group-text"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                >
                  <i
                    className={
                      showPassword
                        ? "ri-eye-off-line"
                        : "ri-eye-line"
                    }
                  />
                </span>
              </div>

              {errors.password && (<div className="invalid-feedback d-block"> {errors.password.message} </div>)}
            </div>
          )}
          {/* Status */}
          {!isDealerEdit && (
            <div className="form-group col-md-6">
              <label className="form-label fw-semibold">
                Status
              </label>

              <div className="d-flex align-items-center gap-2 ">
                <div className="form-check form-switch m-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="isActiveSwitch"
                    {...register("isActive")}
                  />
                </div>

                <span className="fw-semibold">
                  {watch("isActive") ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
          )}
          {/* Buttons */}
          <div className="col-md-12 d-flex justify-content-end gap-3">
            <Button
              title="Close"
              buttonType="button"
              variant="secondary"
              onClick={closeModal}
              icon={<i className="ri-close-circle-line me-1"></i>}
              disable={createDealerLoading}
            />

            <Button
              title={!isDealerEdit ? "Submit" : "Update"}
              buttonType="submit"
              variant="primary"
              icon={<i className="ri-send-plane-fill me-1"></i>}
              loading={createDealerLoading}
            />
          </div>

        </form>
      </Modal>

      <Modal
        showModal={openSuccessModal}
        title="Dealer Created Successfully"
        onHide={closeModal}
        width={400}
        showFooter={false}
      >
        <div className="row">
          <div className="col-md-12">
            <div className="text-center">
              <i className="ri-checkbox-circle-fill text-success" style={{ fontSize: '60px' }}></i>
              <p className="name" style={{ fontWeight: '500' }}>Would you like to configure page access for this dealer now?
                <br />
                Click <span className="fw-semibold text-primary">Continue</span> to proceed.</p>
            </div>
          </div>



          <div className="d-flex justify-content-end mt-4 gap-3">
            <Button
              title="Close"
              buttonType="button"
              variant="secondary"
              onClick={closeModal}
              icon={<i className="ri-close-circle-line me-1"></i>}
              disable={createDealerLoading}
              style={{ padding: "4px 18px", fontWeight: '600', fontSize: '15px' }}
            />

            <Button
              title="Continue"
              buttonType="button"
              variant="primary"
              onClick={handlePageAccess}
              icon={<i className="ri-arrow-right-line me-1"></i>}
              loading={createDealerLoading}
              style={{ padding: "4px 18px", fontWeight: '600', fontSize: '15px' }}
            />
          </div>
        </div>
      </Modal>

      <Modal
        showModal={showResetModal}
        title="Reset Password"
        width={500}
        showFooter={false}
        onHide={() => {
          resetResetPw();
          setShowResetModal(false);
          setSelectedDealer(null);
          setShowNewPassword(false);
          setShowConfirmPassword(false);
        }}
      >
        <form onSubmit={handleSubmitResetPw(handleDealerResetPassword)}>
          <div className="row">

            <div className="col-md-12 mb-3">
              <label className="form-label fw-semibold">
                Password <span className="text-danger">*</span>
                <span
                  className="position-relative ms-2 info-icon-wrapper"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fas fa-info-circle text-primary fs-5 info-icon-text" />
                  <div className="password-info-popup position-absolute bg-white border rounded shadow-sm py-2">
                    <ul className="mb-0 ps-4 custom-info-list">
                      <li className="mb-1"> Minimum characters 8 </li>
                      <li className="mb-1"> One uppercase character </li>
                      <li className="mb-1"> One lowercase character </li>
                      <li className="mb-1"> One special character </li>
                      <li className="mb-1"> One number </li>
                      <li className="mb-1"> e.g. Example@123 </li>
                    </ul>
                  </div>
                </span>
              </label>
              <div className="input-group">
                <input
                  type={showNewPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter Password"
                  {...registerResetPw("newpass", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Minimum 8 characters required",
                    },
                    pattern: {
                      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&_])[A-Za-z\d@$!%*?#&_]{8,}$/,
                      message: "Invalid password format (Example@123)",
                    },

                  })}
                />
                <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowNewPassword(!showNewPassword)}>
                  <i className={showNewPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                </span>
              </div>
              {errorsResetPw.newpass && (<div className="invalid-feedback d-block"> {errorsResetPw.newpass.message} </div>)}
            </div>

            <div className="col-md-12 mb-3">
              <label className="form-label fw-semibold">
                Confirm New Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Confirm New Password"
                  {...registerResetPw("confirmPassword", {
                    required: "Confirm Password is required",
                    validate: (value) => value === watchResetPw("newpass") || "Passwords do not match",
                  })}
                />
                <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  <i className={showConfirmPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                </span>
              </div>
              {errorsResetPw.confirmPassword && (<div className="invalid-feedback d-block"> {errorsResetPw.confirmPassword.message} </div>)}

            </div>
            <div className="col-md-12 mt-2 d-flex justify-content-end">

              <Button
                title="Update Password"
                buttonType="submit"
                variant="primary"
                loading={resetPasswordByAdminLoading}
                disable={resetPasswordByAdminLoading}
                icon={<i className="ri-rotate-lock-line fs-5 me-1"></i>}
              />

            </div>
          </div>

        </form>
      </Modal>

    </CardLayout>
  );
};
export default Dealer;
